import { useEffect, useMemo } from 'react'

import { useFragment } from '@apollo/client'
import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { InboxTaskListItemFragmentDoc } from 'generated/resources/graphql'

import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'
import i18n from 'modules/core/lib/i18n'

import { isTaskFlaggedToBeDiscarded } from 'modules/inbox_tasks/lib/helpers'

type Data = {
  id: string
}

export const NoPermissionTaskActivity: ActivityComponent<Data> = ({ id }) => {
  const { open, closeActivity } = useActivity()

  const { data } = useFragment({
    fragment: InboxTaskListItemFragmentDoc,
    fragmentName: 'InboxTaskListItem',
    from: {
      __typename: 'TasksInboxTask',
      id,
    },
  })

  const flaggedToBeDiscarded = isTaskFlaggedToBeDiscarded(data)

  useEffect(() => {
    if (!flaggedToBeDiscarded) {
      closeActivity()
    }
  }, [flaggedToBeDiscarded, closeActivity])

  const header = useMemo(
    () => ({
      title: i18n.t('tasks.no_permission_task.title'),
      description: i18n.t('tasks.no_permission_task.description'),
      type: 'critical',
    }),
    []
  )

  return <Dialog header={header} onClose={closeActivity} open={open} />
}
